import { inject, Injectable } from '@angular/core';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { CityNavigateHelperService } from './city-navigate-helper.service';
import { withCacheErrorHandling } from '@lentau/core/app-state-cache/shared/cache-error.decorator';
import { AppCacheKeys } from '@lentau/core/app-state-cache/shared/cache.constants';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { getDefaultCitySlugFactory } from './default-city-slug.factory';

@Injectable({
  providedIn: 'root',
})
export class CitySlugCacheService {
  private appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  private cityNavigateHelperService: CityNavigateHelperService = inject(CityNavigateHelperService);
  private browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);
  private readonly defaultCitySlug: string = getDefaultCitySlugFactory().create();

  // Для SSR используется дефолтный город бренда.
  // Для клиента сперва проверяем кэш и поддомен в url; если нет, берем дефолтный город бренда.
  @withCacheErrorHandling(AppCacheKeys.CitySlug)
  public getInitCitySlug(): string {
    if (this.browserApiSupportService.isSearchBot() || isUtk()) {
      return this.defaultCitySlug;
    }

    let citySlug: string | null = this.appStateCacheService.get(AppCacheKeys.CitySlug);

    // Если кеш пустой и нет поддомена, то записать в кеш дефолтное значение
    if (!citySlug) {
      citySlug = this.cityNavigateHelperService.urlHasCitySlug
        ? this.cityNavigateHelperService.regionByUrl
        : this.defaultCitySlug;
      this.appStateCacheService.set(AppCacheKeys.CitySlug, citySlug);
    }

    return citySlug || '';
  }

  public updateCacheCitySlug(citySlug: string | null): void {
    const currentCacheCitySlug: string = this.appStateCacheService.get(AppCacheKeys.CitySlug);

    if (!currentCacheCitySlug || currentCacheCitySlug !== citySlug) {
      this.appStateCacheService.set(AppCacheKeys.CitySlug, citySlug);
    }
  }
}
